"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const hauler_manager_style_1 = __importDefault(require("../hauler-manager.style"));
const grid_1 = __importDefault(require("components/templates/grid"));
const react_router_dom_1 = require("react-router-dom");
const hauler_manager_action_1 = __importDefault(require("../hauler-manager.action"));
const react_1 = require("react");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const svg_1 = require("components/atoms/svg");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const authorization_1 = require("utils/authorization");
const modal_1 = require("components/molecules/modal");
const hauler_manager_mutation_component_1 = __importDefault(require("./hauler-manager.mutation.component"));
const hauler_manager_column_1 = require("../hauler-manager.column");
const debounces_1 = require("utils/debounces");
const HaulerManager = () => {
    const { dataGrid, dataStates, isLoading, isSuccess, isError, errorMessage, } = (0, store_1.useAppSelector)(state => state.configuration.haulerManager);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const debounceCallback = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(hauler_manager_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Configuration', 'Hauler');
    const handleExternalInternalState = (isExternal) => {
        var _a;
        if (isExternal) {
            const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: {
                    logic: 'and',
                    filters: [
                        ...((_a = dataStates.filter) === null || _a === void 0 ? void 0 : _a.filters) || [],
                        { field: 'contractor_name', operator: 'eq', value: userData.contractor_name }
                    ]
                } });
            return newDataStates;
        }
        else {
            return dataStates;
        }
    };
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(hauler_manager_action_1.default.getDataGrid(handleExternalInternalState(isExternal)));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen, isExternal]);
    const actionCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(hauler_manager_action_1.default.onClickMutation({ mutationMode: 'edit', dataItem: d })),
            permission: isAuthorized.change
        },
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(hauler_manager_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d })),
            permission: isAuthorized.change
        }
    ]);
    const actionColumn = [{
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true
        }];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(hauler_manager_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(hauler_manager_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debounceCallback(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(hauler_manager_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        dispatch(hauler_manager_action_1.default.getDataGrid(newDataStates));
    };
    const columnsRender = isExternal
        ? hauler_manager_column_1.HaulerManagerColumnProps.map(item => {
            if (item.field === 'contractor_name') {
                return Object.assign(Object.assign({}, item), { filterable: false });
            }
            else {
                return item;
            }
        })
        : hauler_manager_column_1.HaulerManagerColumnProps;
    const columnsRenderFullScreen = isExternal
        ? hauler_manager_column_1.HaulerManagerColumnFullScreenProps.map(item => {
            if (item.field === 'contractor_name') {
                return Object.assign(Object.assign({}, item), { filterable: false });
            }
            else {
                return item;
            }
        })
        : hauler_manager_column_1.HaulerManagerColumnFullScreenProps;
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'Hauler', theme: appTheme, isLoading: isLoading, isAddNew: isAuthorized.change, onAddNew: () => dispatch(hauler_manager_action_1.default.onClickMutation({ mutationMode: 'add' })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(hauler_manager_action_1.default.getDataGrid(dataStates));
                    dispatch(hauler_manager_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, errorMessage: errorMessage, onClose: () => dispatch(hauler_manager_action_1.default.onCloseError()), style: { 'zIndex': 10 } }), (0, jsx_runtime_1.jsx)(hauler_manager_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(grid_1.default, { style: hauler_manager_style_1.default.gridHeight, fullScreen: fullScreen, dataGrid: dataGrid, columns: actionColumn.concat(fullScreen ? columnsRenderFullScreen : columnsRender), dataStates: dataStates, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange })] }));
};
exports.default = HaulerManager;
